const DEFAULT_POLAR_CHECKOUT_URL =
  "https://buy.polar.sh/polar_cl_gOkRSU72ZkoG9FPriChXAyiF5rHxOfkd72R0A2Emqsp";

export function getPolarCheckoutUrl(): string {
  return process.env.NEXT_PUBLIC_POLAR_CHECKOUT_URL || DEFAULT_POLAR_CHECKOUT_URL;
}

/** Append the PostHog distinct_id as Polar's `reference_id` (propagates into
 *  order/subscription metadata for closed-loop attribution). No-ops for non-Polar hrefs. */
export function withCheckoutReference(href: string, distinctId: string): string {
  try {
    const u = new URL(href);
    if (u.hostname !== 'buy.polar.sh') return href;
    if (!u.searchParams.has('reference_id')) u.searchParams.set('reference_id', distinctId);
    return u.toString();
  } catch { return href; }
}



